// Titres (≤ 60 caractères environ) et descriptions (≤ 160) des pages fixes.
// Pages métiers, guides et pages piliers : générés depuis leurs propres données.
export const SEO_META = {
  "/": {
    title: "Assurance décennale artisan : prix par métier, devis gratuit",
    desc: "RC Pro + décennale des artisans du BTP : prix indicatifs de 1 000 à 7 000 €/an selon le métier, guides pratiques et devis gratuit sans engagement. 22 métiers.",
  },
  "/metiers": {
    title: "Assurance décennale par métier : prix de 22 métiers du BTP",
    desc: "Maçon, couvreur, électricien, plombier… Prix indicatifs par an et par mois, travaux à déclarer et pièges à éviter pour 22 métiers du bâtiment. Devis gratuit.",
  },
  "/prix": {
    title: "Prix assurance décennale 2026 : tarifs par métier et par mois",
    desc: "Combien coûte une décennale ? Tarifs indicatifs 2026 de 22 métiers, par an et par mois (maçon : 3 000–5 000 €/an), critères de prix et estimation gratuite.",
  },
  "/attestation": {
    title: "Attestation décennale : comment l’obtenir et la vérifier",
    desc: "Attestation d’assurance décennale : contenu, délai de délivrance, obligation de la joindre aux devis et factures, points à contrôler avant l’ouverture du chantier.",
  },
  "/guide": {
    title: "Guides assurance décennale : refus, devis, résiliation, BCT",
    desc: "9 guides pratiques sur la décennale : création d’entreprise, refus et BCT, mentions sur devis, résiliation, cessation d’activité, sous-traitance, garanties.",
  },
  "/sante": {
    title: "Mutuelle santé TNS et salariés pour artisans du BTP",
    desc: "Complémentaire santé pour dirigeants TNS (loi Madelin) et santé collective obligatoire pour vos salariés. Conseils et devis pour artisans du bâtiment.",
  },
  "/prevoyance": {
    title: "Prévoyance artisan TNS : arrêt de travail, invalidité, décès",
    desc: "Prévoyance pour artisans et dirigeants TNS : maintenez vos revenus en cas d'arrêt de travail, invalidité ou décès. Cotisations déductibles loi Madelin.",
  },
  "/devis": {
    title: "Devis assurance décennale gratuit en 2 minutes",
    desc: "Demandez votre devis RC Pro + décennale en 2 minutes : gratuit, sans engagement, rappel par un conseiller spécialiste du bâtiment. Création d’entreprise étudiée.",
  },
  "/contact": {
    title: "Contact — Decennale Artisans",
    desc: "Contactez Decennale Artisans via notre formulaire : question sur un devis, la santé TNS, la prévoyance ou un partenariat. Réponse rapide par écrit.",
  },
  "/comparatif-assurance-decennale": {
    title: "Comparatif assurance décennale : 15 acteurs | Decennale Artisans",
    desc: "Comparez les informations publiques de 15 acteurs de la décennale : offres documentées, points à vérifier et sources officielles.",
  },
  "/a-propos": {
    title: "À propos de Décennale Artisans : qui sommes-nous ?",
    desc: "Qui édite Décennale Artisans, comment les demandes de devis sont étudiées, comment nos guides sont rédigés et vérifiés, et comment nous contacter.",
  },
  "/cgu": {
    title: "Conditions Générales d'Utilisation | Decennale Artisans",
    desc: "Conditions générales d'utilisation du site decennale-artisans.com : service de mise en relation, engagements, protection des données personnelles.",
  },
  "/confidentialite": {
    title: "Politique de confidentialité | Decennale Artisans",
    desc: "Politique de confidentialité de decennale-artisans.com : collecte, finalités, durée de conservation et vos droits sur vos données personnelles (RGPD).",
  },
  "/mentions-legales": {
    title: "Mentions légales | Decennale Artisans",
    desc: "Mentions légales du site decennale-artisans.com : éditeur, intermédiaire en assurance, hébergement et propriété intellectuelle.",
  },
  "/informations-reglementaires": {
    title: "Informations réglementaires — intermédiaire en assurance",
    desc: "Informations réglementaires de decennale-artisans.com : intermédiation en assurance, ORIAS, rémunération, réclamations et médiation (Code des assurances).",
  },
  "/admin": { title: "Administration", desc: "", noindex: true },
  "/admin/login": { title: "Connexion", desc: "", noindex: true },
};
